<template>
    <div class="biz-view-mode">
        <div class="biz-view-mode-wrap">
            <span class="list-mode" :class="{'active': mode == 'list'}" @click="changeMode('list')">
                <img v-if="mode == 'list'" src="@/assets/img/icon/list_mode_black.png" alt="">
                <img v-else src="@/assets/img/icon/list_mode_gray.png" alt="">
                列表模式
            </span>
            <span class="graph-mode" :class="{'active': mode == 'graph'}" @click="changeMode('graph')">
                <img v-if="mode == 'graph'" src="@/assets/img/icon/graph_mode_black.svg" alt="">
                <img v-else src="@/assets/img/icon/graph_mode_gray.svg" alt="">
                圖表模式
            </span>
            <!-- <span class="map-mode" :class="{'active': mode == 'map'}" @click="changeMode('map')">
                <img v-if="mode == 'map'" src="@/assets/img/icon/map_mode_black.svg" alt="">
                <img v-else src="@/assets/img/icon/map_mode_gray.svg" alt="">
                地圖模式
            </span> -->
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
        }
    },
    methods: {
        changeMode: function (mode) {
            this.$store.dispatch('setBizHouseMgtMode', mode)
            if( mode == 'list'){
                this.$router.push({name: 'bizHouseMgtDefault'})
            }else if( mode == 'graph' ){
                this.$router.push({name: 'bizHouseMgtDefault', query:{'mode': 'graph'}})
            }else if( mode == 'map' ){
                this.$router.push({name: 'bizMapSearch'})
            }
        }
    },
    computed: {
        ...mapGetters({
            mode: 'GET_BIZ_HOUSE_MGT_MODE',
        })
    }
}
</script>
<style lang="scss" scoped>
    .biz-view-mode{
        width: 204px;
        height: 44px;
        border: solid 1px #f0f0f0;
        background-color: #ffffff;
        border-radius: 4px;
        .biz-view-mode-wrap{
            display: flex;
            padding: 6px;
            span{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 94px;
                height: 32px;
                border-radius: 3px;
                font-size: 12px;
                color: #a8a5a4;
                cursor: pointer;
            }
            span.active{
                box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);
                color: #676362;
                background-color: #f6f6f6;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/houseMgt/houseMgtModeSwitch.vue